import { getWhiteLabelBrandByHost } from '../constants/white-label-brands';

const upsertMetaTag = ({ selector, attribute, value, content }) => {
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    Object.entries(attribute).forEach(([key, attrValue]) => {
      tag.setAttribute(key, attrValue);
    });
    document.head.appendChild(tag);
  }

  tag.setAttribute(value, content);
};

const setMetaByName = (name, content) => {
  upsertMetaTag({
    selector: `meta[name="${name}"]`,
    attribute: { name },
    value: 'content',
    content,
  });
};

const setMetaByProperty = (property, content) => {
  upsertMetaTag({
    selector: `meta[property="${property}"]`,
    attribute: { property },
    value: 'content',
    content,
  });
};

const upsertCanonicalLink = (href) => {
  let tag = document.head.querySelector('link[rel="canonical"]');

  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }

  tag.setAttribute('href', href);
};

const upsertFavicon = (href) => {
  document.head
    .querySelectorAll('link[rel="shortcut icon"], link[rel="icon"]')
    .forEach((tag) => tag.remove());

  const tag = document.createElement('link');
  tag.setAttribute('rel', 'icon');
  tag.setAttribute('href', href);
  document.head.appendChild(tag);
};

export const applyWhiteLabelSeo = () => {
  const whiteLabelBrand = getWhiteLabelBrandByHost();

  if (!whiteLabelBrand) {
    return;
  }

  const { title, description, faviconUrl } = whiteLabelBrand;
  const currentUrl = window.location.href;

  document.title = title;

  if (faviconUrl) {
    upsertFavicon(faviconUrl);
  }

  upsertCanonicalLink(currentUrl);
  setMetaByName('description', description);
  setMetaByProperty('og:type', 'website');
  setMetaByProperty('og:site_name', title);
  setMetaByProperty('og:title', title);
  setMetaByProperty('og:description', description);
  setMetaByProperty('og:url', currentUrl);
  setMetaByName('twitter:card', 'summary');
  setMetaByName('twitter:title', title);
  setMetaByName('twitter:description', description);
};



// WEBPACK FOOTER //
// ./src/helpers/whiteLabelSeoHelper.js